import React, { useContext, useRef, useState } from 'react'
import { Fade, Paper } from '@material-ui/core'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { PencilIcon, WalletIcon } from './assets'
import { useOnClickOutside } from './components'
import Popper from './AltPopper'
import { billing_period_options } from '../../../Constants'
import './styles.scss'
import { SessionContextStore } from '../../../context/SessionContext'
import { StatesContextStore } from '../../../context/StatesContext'
import { BillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'

export default () => {
  const ref = useRef(null)
  const [open, setOpen] = useState(false)
  useOnClickOutside(ref, () => setOpen(false))

  const { billingPeriodEnabled, billingPeriod, billingPeriodDiscount, setBillingPeriod } = useContext(BuyingInsuranceContextStore)
  const statesContextStore = useContext(StatesContextStore)
  const sessionContext = useContext(SessionContextStore)

  return billingPeriodEnabled ? (
    <div style={{ padding: '0 .5rem' }}>
      <div className="flex align-center" style={{ height: '2rem', fontSize: '12px', borderTop: '1px solid #bcbab9' }}>
        <Popper open={open} anchorEl={ref.current} arrow={true} flip={true} placement="left-end" transition>
          {({ arrow, TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <div>
                {arrow}
                <Paper>
                  <div className=" billing">
                    {Object.values(billing_period_options)
                      .filter(
                        x =>
                          !(
                            x.value === BillingPeriod.SIXMONTHS &&
                            statesContextStore.new_estimated_flow.includes(sessionContext.user.administrativeDivision)
                          )
                      )
                      .map(option => (
                        <div
                          key={option.value}
                          onClick={() => {
                            setBillingPeriod(option.value)
                            setOpen(false)
                          }}
                          style={{ fontWeight: option.value === billingPeriod ? 'bold' : 'normal' }}
                        >
                          {option.label === 'Annual' ? 'Annually' : option.label}
                          {option.value in billingPeriodDiscount && (
                            <div className="discount">
                              {billingPeriodDiscount[option.value].toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}{' '}
                              off
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </Paper>
              </div>
            </Fade>
          )}
        </Popper>
        <WalletIcon />
        <div style={{ marginLeft: '.4rem' }}>Payment Reccurence</div>
        <div style={{ marginLeft: 'auto', textDecoration: 'underline' }} ref={ref} onClick={() => setOpen(!open)}>
          {billing_period_options[billingPeriod].label} <PencilIcon />
        </div>
      </div>
    </div>
  ) : null
}
